import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { delay, first, from, map, Observable, of, switchMap } from 'rxjs';
import {
  ActionModalComponent,
  AppRoutes,
  ENV_CONFIG,
  EnvConfig,
  MODAL_TOKEN,
  ModalProvider,
  PLATFORM_TOKEN,
  PlatformProvider
} from '@core';
import { getNewVersionNative } from '../utils';
import { UpdateService, VersionConfigSyncService } from '@update/infra';

export const UpdateGuard = (): Observable<boolean> => {
  const router: Router = inject(Router);
  const updateService: UpdateService = inject(UpdateService);
  const modalToken: ModalProvider = inject(MODAL_TOKEN);
  const platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);
  const versionConfigSyncService: VersionConfigSyncService = inject(VersionConfigSyncService);
  const env: EnvConfig = inject(ENV_CONFIG);

  const openModal = (): Observable<false> => {
    router.navigate([`/${AppRoutes.BLOCKED_VERSION}`]);

    return modalToken
      .showModal$({
        component: ActionModalComponent,
        componentProps: {
          header: 'Mamy dla Ciebie nową wersję aplikacji!',
          message: ' Aby wszystko działało poprawnie, prosimy o aktualizację.',
          btnOk: 'Pobierz aktualizację',
          btnCancel: 'Anuluj',
          action: () => getNewVersionNative(platformProvider, env)
        },
        cssClass: 'present-modal'
      })
      .pipe(
        switchMap(() => from(versionConfigSyncService.sync())),
        delay(500),
        map(() => false)
      );
  };

  if (!platformProvider.isNativeRun) return of(true);

  return updateService.isUpdated().pipe(
    first(),
    switchMap((isUpdated: boolean) => (!isUpdated ? openModal() : of(true)))
  );
};
